const initialState = {
    applications:[],
     
   
   };
   
   const PatientApplicationsReducers = (state = initialState, action: any) => {
     switch (action.type) {
             case 'FETCH_DATA_SUCCESS':
             return {... state, applications:action.payload};
             
             
             
             
             
            
             
            
           
 
 
       default:
         return state;
     }
   };
   
   export default PatientApplicationsReducers;
   
   